import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import ProfileFormWrapper from './components/ProfileFormWrapper';
import ProfileSubnav from './components/ProfileSubnav';
import CurrentProfileProvider from './providers/CurrentProfile/CurrentProfile.provider';
import BossModeBanner from '../Portfolio/subrouters/Seller/subrouters/ListingDetailSeller/subrouters/ListingInformation/components/BossModeBanner';
import { ADMIN_DASHBOARD_ROUTE } from 'data/global';
import UserEnquiryContextContainer from 'components/UserEnquiryContextContainer';
import BannerWrapper from 'components/BannerWrapper';
import { COLOR_VARIANT } from 'models/Colors';
import DiscoveryFeatureCard from 'components/DiscoveryFeatureCard';
import { FIRST_RELEASE_DISCOVERING_FEATURE } from 'data/discoveringFeature';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './Profile.styles.scss';

const ProfileRouter: React.FC = () => {
  const {
    currentUser: { seenEnquiryContextFeature },
    updatePreferences,
  } = useContext(CurrentUserContext);

  const { pathname } = useLocation();

  const { t } = useTranslation();

  const isBossMode = pathname.includes(ADMIN_DASHBOARD_ROUTE);
  const isPreferencesPage = pathname.endsWith('/profile');

  const discoveryCard = useMemo(
    () => (
      <DiscoveryFeatureCard
        className="preferences-page__discovery-card"
        title={t('enquiryContextDiscoveryTitle')}
        description={t('enquiryContextDiscoveryBannerDescription')}
        createdAt={FIRST_RELEASE_DISCOVERING_FEATURE}
        onUnderstood={() =>
          updatePreferences({ seenEnquiryContextFeature: true })
        }
      />
    ),
    [t, updatePreferences],
  );

  const renderDiscoveryBanner =
    !isBossMode && !seenEnquiryContextFeature && discoveryCard;

  return (
    <CurrentProfileProvider>
      <div className="profile-router">
        {isBossMode && (
          <BossModeBanner description={t('beCarefulEditingCustomerInfo')} />
        )}

        <h1>{t('accountSettings')}</h1>
        <ProfileSubnav isBossMode={isBossMode} />

        {isPreferencesPage && (
          <>
            {renderDiscoveryBanner && (
              <BannerWrapper
                className="preferences-page__discovery-banner"
                color={COLOR_VARIANT.PRIMARY}
              >
                {discoveryCard}
              </BannerWrapper>
            )}
            <UserEnquiryContextContainer className="profile-card-container" />
          </>
        )}

        <ProfileFormWrapper>
          <Outlet />
        </ProfileFormWrapper>
      </div>
    </CurrentProfileProvider>
  );
};

export default ProfileRouter;
